import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

// Masked password field with an accessible Show/Hide toggle.
// Toggling only flips the input type — it never clears, resubmits, or alters
// the value or autocomplete, so password managers / autofill keep working.
export function PasswordInput({ className = "", ...props }) {
  const [show, setShow] = useState(false);
  const tid = props["data-testid"];
  return (
    <div className={`relative ${className}`}>
      <input {...props} type={show ? "text" : "password"} className="sg-input w-full pr-11" />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        aria-label={show ? "Hide password" : "Show password"}
        aria-pressed={show}
        tabIndex={-1}
        data-testid={tid ? `${tid}-toggle` : "password-toggle"}
        className="absolute right-0 top-0 h-full px-3 flex items-center justify-center"
        style={{ color: "var(--txt2)", background: "none", border: "none", cursor: "pointer" }}
      >
        {show ? <EyeOff size={18} /> : <Eye size={18} />}
      </button>
    </div>
  );
}
